import { useMemo } from 'react';
import { isProfile } from './isProfile';
import { SearchResultItem, SearchResultNonProfile } from './types';

export const useNonProfilesOnly = (results: SearchResultItem[]): SearchResultNonProfile[] =>
  useMemo(() => results.flatMap(it => (!isProfile(it) ? [it] : [])), [results]);
